// Curated interval source material for rationalisation scoring.
// These lists are not the user's scale; they are reference vocabularies used to
// recognise musically useful dyads, neighbouring families, and overtonal paths.

const RAW_TUNEABLE_INTERVALS = [
  [[1, 1], 0],
  [[9, 8], 203.91000173077484],
  [[8, 7], 231.174093530875],
  [[7, 6], 266.870905603738],
  [[6, 5], 315.641287000553],
  [[11, 9], 347.407940633982],
  [[5, 4], 386.313713864835],
  [[9, 7], 435.08409526165],
  [[41, 32], 429.5513896917525],
  [[13, 10], 454.213947904476],
  [[4, 3], 498.044999134613],
  [[11, 8], 551.317942364757],
  [[7, 5], 582.51219260429],
  [[10, 7], 617.48780739571],
  [[13, 9], 636.617660038536],
  [[16, 11], 648.682057635243],
  [[3, 2], 701.955000865388],
  [[14, 9], 764.91590473835],
  [[11, 7], 782.492035895632],
  [[8, 5], 813.686286135165],
  [[13, 8], 840.527661769311],
  [[5, 3], 884.358712999448],
  [[12, 7], 933.129094396262],
  [[7, 4], 968.825906469125],
  [[9, 5], 1017.59628786594],
  [[11, 6], 1049.36294149937],
  [[13, 7], 1071.70175530019],
  [[15, 8], 1088.26871473022],
  [[23, 12], 1126.31934640303],
  [[2, 1], 1200],
  [[13, 6], 1338.57266090392],
  [[11, 5], 1365.00422849992],
  [[9, 4], 1403.91000173077],
  [[7, 3], 1466.87090560374],
  [[19, 8], 1497.5130161323],
  [[12, 5], 1515.64128700055],
  [[17, 7], 1536.12950303128],
  [[5, 2], 1586.31371386483],
  [[18, 7], 1635.08409526165],
  [[13, 5], 1654.21394790448],
  [[8, 3], 1698.04499913461],
  [[11, 4], 1751.31794236476],
  [[14, 5], 1782.51219260429],
  [[17, 6], 1803.00040863502],
  [[20, 7], 1817.48780739571],
  [[23, 8], 1828.27434726842],
  [[3, 1], 1901.95500086539],
  [[28, 9], 1964.91590473835],
  [[25, 8], 1972.62742772967],
  [[22, 7], 1982.49203589563],
  [[19, 6], 1995.55801526692],
  [[16, 5], 2013.68628613517],
  [[13, 4], 2040.52766176931],
  [[10, 3], 2084.35871299945],
  [[27, 8], 2105.86500259616],
  [[17, 5], 2118.64169563557],
  [[24, 7], 2133.12909439626],
  [[7, 2], 2168.82590646912],
  [[18, 5], 2217.59628786594],
  [[11, 3], 2249.36294149937],
  [[15, 4], 2288.26871473022],
  [[19, 5], 2311.19930226747],
  [[23, 6], 2326.31934640303],
  [[27, 7], 2337.03909612704],
  [[4, 1], 2400],
  [[25, 6], 2470.67242686428],
  [[21, 5], 2484.46719346968],
  [[17, 4], 2504.95540950041],
  [[13, 3], 2538.57266090392],
  [[22, 5], 2565.00422849992],
  [[9, 2], 2603.91000173077],
  [[23, 5], 2641.96063340358],
  [[14, 3], 2666.87090560374],
  [[19, 4], 2697.5130161323],
  [[24, 5], 2715.64128700055],
  [[5, 1], 2786.31371386484],
  [[26, 5], 2854.21394790448],
  [[21, 4], 2870.78090733451],
  [[16, 3], 2898.04499913461],
  [[11, 2], 2951.31794236476],
  [[28, 5], 2982.51219260429],
  [[17, 3], 3003.00040863502],
  [[23, 4], 3028.27434726841],
  [[6, 1], 3101.95500086539],
  [[25, 4], 3172.62742772967],
  [[19, 3], 3195.55801526691],
  [[13, 2], 3240.52766176931],
  [[20, 3], 3284.35871299945],
  [[27, 4], 3305.86500259616],
  [[7, 1], 3368.82590646913],
  [[22, 3], 3449.36294149937],
  [[15, 2], 3488.26871473022],
  [[23, 3], 3526.31934640303],
  [[8, 1], 3600],
];

const RAW_INTERVAL_NEIGHBORHOOD_CHAIN = [
  [1, 1],
  [28, 27],
  [27, 26],
  [26, 25],
  [25, 24],
  [24, 23],
  [23, 22],
  [22, 21],
  [21, 20],
  [20, 19],
  [19, 18],
  [18, 17],
  [17, 16],
  [16, 15],
  [15, 14],
  [14, 13],
  [27, 25],
  [13, 12],
  [25, 23],
  [12, 11],
  [23, 21],
  [11, 10],
  [21, 19],
  [10, 9],
  [19, 17],
  [28, 25],
  [9, 8],
  [26, 23],
  [17, 15],
  [25, 22],
  [8, 7],
  [23, 20],
  [15, 13],
  [22, 19],
  [7, 6],
  [27, 23],
  [20, 17],
  [13, 11],
  [19, 16],
  [25, 21],
  [6, 5],
  [23, 19],
  [17, 14],
  [28, 23],
  [11, 9],
  [27, 22],
  [16, 13],
  [21, 17],
  [26, 21],
  [5, 4],
  [24, 19],
  [19, 15],
  [14, 11],
  [23, 18],
  [9, 7],
  [22, 17],
  [13, 10],
  [17, 13],
  [21, 16],
  [25, 19],
  [4, 3],
  [27, 20],
  [23, 17],
  [19, 14],
  [15, 11],
  [26, 19],
  [11, 8],
  [18, 13],
  [25, 18],
  [7, 5],
  [24, 17],
  [17, 12],
  [27, 19],
  [10, 7],
  [23, 16],
  [13, 9],
  [16, 11],
  [19, 13],
  [22, 15],
  [25, 17],
  [28, 19],
  [3, 2],
  [26, 17],
  [23, 15],
  [20, 13],
  [17, 11],
  [14, 9],
  [25, 16],
  [11, 7],
  [19, 12],
  [27, 17],
  [8, 5],
  [21, 13],
  [13, 8],
  [18, 11],
  [23, 14],
  [28, 17],
  [5, 3],
  [27, 16],
  [22, 13],
  [17, 10],
  [12, 7],
  [19, 11],
  [26, 15],
  [7, 4],
  [23, 13],
  [16, 9],
  [25, 14],
  [9, 5],
  [20, 11],
  [11, 6],
  [24, 13],
  [13, 7],
  [28, 15],
  [15, 8],
  [17, 9],
  [19, 10],
  [21, 11],
  [23, 12],
  [25, 13],
  [27, 14],
  [2, 1],
  [27, 13],
  [25, 12],
  [23, 11],
  [21, 10],
  [19, 9],
  [17, 8],
  [15, 7],
  [28, 13],
  [13, 6],
  [24, 11],
  [11, 5],
  [20, 9],
  [9, 4],
  [25, 11],
  [16, 7],
  [23, 10],
  [7, 3],
  [26, 11],
  [19, 8],
  [12, 5],
  [17, 7],
  [22, 9],
  [27, 11],
  [5, 2],
  [28, 11],
  [23, 9],
  [18, 7],
  [13, 5],
  [21, 8],
  [8, 3],
  [27, 10],
  [19, 7],
  [11, 4],
  [25, 9],
  [14, 5],
  [17, 6],
  [20, 7],
  [23, 8],
  [26, 9],
  [3, 1],
  [28, 9],
  [25, 8],
  [22, 7],
  [19, 6],
  [16, 5],
  [13, 4],
  [23, 7],
  [10, 3],
  [27, 8],
  [17, 5],
  [24, 7],
  [7, 2],
  [25, 7],
  [18, 5],
  [11, 3],
  [26, 7],
  [15, 4],
  [19, 5],
  [23, 6],
  [27, 7],
  [4, 1],
  [25, 6],
  [21, 5],
  [17, 4],
  [13, 3],
  [22, 5],
  [9, 2],
  [23, 5],
  [14, 3],
  [19, 4],
  [24, 5],
  [5, 1],
  [26, 5],
  [21, 4],
  [16, 3],
  [27, 5],
  [11, 2],
  [28, 5],
  [17, 3],
  [23, 4],
  [6, 1],
  [25, 4],
  [19, 3],
  [13, 2],
  [20, 3],
  [27, 4],
  [7, 1],
  [22, 3],
  [15, 2],
  [23, 3],
  [8, 1],
];

const RAW_OVERTONAL_SOURCE_SET = [
  [129, 128],
  [65, 64],
  [33, 32],
  [133, 128],
  [135, 128],
  [17, 16],
  [69, 64],
  [35, 32],
  [141, 128],
  [143, 128],
  [9, 8],
  [145, 128],
  [147, 128],
  [37, 32],
  [75, 64],
  [19, 16],
  [153, 128],
  [77, 64],
  [155, 128],
  [39, 32],
  [5, 4],
  [161, 128],
  [81, 64],
  [41, 32],
  [165, 128],
  [21, 16],
  [169, 128],
  [85, 64],
  [171, 128],
  [43, 32],
  [87, 64],
  [175, 128],
  [11, 8],
  [45, 32],
  [91, 64],
  [23, 16],
  [185, 128],
  [93, 64],
  [187, 128],
  [47, 32],
  [189, 128],
  [95, 64],
  [3, 2],
  [195, 128],
  [49, 32],
  [99, 64],
  [25, 16],
  [203, 128],
  [51, 32],
  [205, 128],
  [207, 128],
  [13, 8],
  [209, 128],
  [105, 64],
  [215, 128],
  [27, 16],
  [217, 128],
  [55, 32],
  [221, 128],
  [111, 64],
  [7, 4],
  [225, 128],
  [57, 32],
  [115, 64],
  [231, 128],
  [29, 16],
  [117, 64],
  [235, 128],
  [119, 64],
  [15, 8],
  [121, 64],
  [243, 128],
  [245, 128],
  [123, 64],
  [247, 128],
  [31, 16],
  [125, 64],
  [63, 32],
  [253, 128],
  [255, 128],
  [2, 1],
];

function ratioPartsToText([numerator, denominator]) {
  return denominator === 1 ? `${numerator}` : `${numerator}/${denominator}`;
}

function defaultToleranceCents(cents) {
  if (cents === 0 || cents === 1200) return 3;
  if (cents < 250 || cents > 950) return 8;
  if (cents < 500 || cents > 700) return 9;
  return 10;
}

function defaultWeightFromRatio([numerator, denominator]) {
  const complexity = numerator + denominator;
  return Math.max(0.45, Math.min(1, 1.15 - complexity / 40));
}

export const DEFAULT_TUNEABLE_INTERVALS = RAW_TUNEABLE_INTERVALS.map(([parts, cents]) => ({
  ratio: ratioPartsToText(parts),
  ratioParts: [...parts],
  cents,
  toleranceCents: defaultToleranceCents(cents),
  weight: defaultWeightFromRatio(parts),
}));

export const DEFAULT_INTERVAL_NEIGHBORHOOD_CHAIN = RAW_INTERVAL_NEIGHBORHOOD_CHAIN.map((parts) =>
  ratioPartsToText(parts),
);

export const DEFAULT_OVERTONAL_SOURCE_SET = RAW_OVERTONAL_SOURCE_SET.map((parts) =>
  ratioPartsToText(parts),
);

export function buildTuneableIntervalIndex(intervals = DEFAULT_TUNEABLE_INTERVALS) {
  return new Map(intervals.map((entry, index) => [entry.ratio, { ...entry, index }]));
}

export function findTuneableFamilyMatches(
  cents,
  { intervals = DEFAULT_TUNEABLE_INTERVALS, toleranceTable = null } = {},
) {
  return intervals
    .map((entry) => {
      const tolerance = toleranceTable?.[entry.ratio] ?? entry.toleranceCents;
      const deviation = Math.abs(cents - entry.cents);
      if (deviation > tolerance) return null;
      return {
        ...entry,
        tolerance,
        deviation,
        score: entry.weight * (1 - deviation / Math.max(tolerance, 0.001)),
      };
    })
    .filter(Boolean)
    .sort((a, b) => b.score - a.score);
}

export function getNeighborFamilies(
  ratioText,
  { chain = DEFAULT_INTERVAL_NEIGHBORHOOD_CHAIN, radius = 2 } = {},
) {
  const index = chain.indexOf(ratioText);
  if (index === -1) return [];
  const start = Math.max(0, index - radius);
  const end = Math.min(chain.length, index + radius + 1);
  return chain.slice(start, end).filter((ratio) => ratio !== ratioText);
}

export function findOvertonalNeighbors(
  ratioText,
  {
    sourceSet = DEFAULT_OVERTONAL_SOURCE_SET,
    chain = DEFAULT_INTERVAL_NEIGHBORHOOD_CHAIN,
    radius = 3,
  } = {},
) {
  const source = new Set(sourceSet);
  const chainNeighbors = getNeighborFamilies(ratioText, { chain, radius }).filter((ratio) =>
    source.has(ratio),
  );
  if (chainNeighbors.length) return chainNeighbors;

  const index = sourceSet.indexOf(ratioText);
  if (index === -1) return [];
  const start = Math.max(0, index - radius);
  const end = Math.min(sourceSet.length, index + radius + 1);
  return sourceSet.slice(start, end).filter((ratio) => ratio !== ratioText);
}
